import { Responsible } from './Responsible.model';
import { Personal } from './Personal.model';
import { Emergency } from './Emergency.model';
import { Contract } from './Contract.model';
import { Payment } from './Payment.model';
import { GroupDivision } from '../shared/enums/GroupDivision';
import { ISubDivisions, SubDivision } from './SubDivision.model';
import { ExcellenceCenter } from "./ExcellenceCenter.model";

export class Consultant {
    _id: string;
    name: string;
    fcEmail: string;
    email: string;
    division: GroupDivision = 0;
    created: Date;
    changed: Date;
    responsible: Responsible = new Responsible();
    bp: Responsible = new Responsible();
    personal: Personal = new Personal();
    emergency: Emergency = new Emergency();
    contract: Contract = new Contract();
    payment: Payment = new Payment();
    active: Boolean;
    x3Id: String;
    consultantStart: string;
    consultantEnd: string;
    contractsHistory: Contract[] = new Array<Contract>();
    documentsClickSign: String[] = new Array<String>();
    sapCardCode: string = '';
    hashTrackId: string = '';
    newContract: Boolean = false;
    generatedConfidentiality: Boolean = false;
    generatedConfidentialityFC: Boolean = false;
    skills: any = [];
    keySigner: string;
    updateCNPJ: boolean = false;
    isBackoffice: boolean;
    freshServiceId: string = '';
    excellenceCenter: ExcellenceCenter = new ExcellenceCenter();
    supportCenter: ExcellenceCenter = new ExcellenceCenter();

    loadConsultantFromServer(r: any) {
        this._id = r._id;
        this.name = r.name;
        this.active = r.active;
        this.newContract = false;

        if (r.division)
            this.division = r.division;

        if (r.fcEmail)
            this.fcEmail = r.fcEmail;

        if (r.email)
            this.email = r.email;

        if (r.x3Id)
            this.x3Id = r.x3Id;

        if (r.consultantStart)
            this.consultantStart = r.consultantStart;

        if (r.consultantEnd)
            this.consultantEnd = r.consultantEnd;

        if (r.contract)
            this.contract.loadToEdit(r.contract);

        if (r.contractsHistory)
            for (let c of r.contractsHistory) {
                let contract = new Contract();
                contract.loadToEdit(c);
                this.contractsHistory.push(contract);
            }

        if(r.documentsClickSign)
            for(let clickSignKey of r.documentsClickSign) {
                this.documentsClickSign.push(clickSignKey);
            }

        if (r.responsible)
            this.responsible.loadUser(r.responsible);

        if (r.bp)
            this.bp.loadUser(r.bp);

        if (r.personal)
            this.personal.loadToEdit(r.personal);

        if (r.emergency)
            this.emergency.loadToEdit(r.emergency);

        if (r.payment)
            this.payment.loadToEdit(r.payment);

        if(r.sapCardCode)
            this.sapCardCode = r.sapCardCode;

        if(r.hashTrackId)
            this.hashTrackId = r.hashTrackId;

        if(r.generatedConfidentiality)
          this.generatedConfidentiality = r.generatedConfidentiality;

        if(r.keySigner)
            this.keySigner = r.keySigner;

        if(r.generatedConfidentialityFC)
            this.generatedConfidentialityFC = r.generatedConfidentialityFC;

        if (r.skills)
            for (let s of r.skills) {
                this.skills.push(s);
            }
        if (r.updateCNPJ)
            this.updateCNPJ = r.updateCNPJ;

        if(r.isBackoffice)
            this.isBackoffice = r.isBackoffice;

        if(r.freshServiceId)
            this.freshServiceId = r.freshServiceId;

        if(r.excellenceCenter)
            this.excellenceCenter.loadFromServer(r.excellenceCenter)

        if(r.supportCenter)
            this.supportCenter.loadFromServer(r.supportCenter)
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Consultant.model.ts